import { Component, EventEmitter, Input, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { ObjectClass } from 'src/app/public/common/constants/common-basic-data';
import { CarBusinessLine } from '../../constants/car-basic-data';
import { CarBrief } from '../../models/car-brief.model';
import { Car } from '../../models/car.model';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';


@Component({
    selector: 'app-car-box',
    templateUrl: './car-box.component.html',
    styleUrls: ['./car-box.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatButtonModule, MatIconModule]
})
export class CarBoxComponent implements OnInit {

  @Input() businessLine?: CarBusinessLine;
  
  @Input() carBrief: CarBrief = new CarBrief();
  
  @Input() isSeller: boolean = false;
  @Input() carImage: Blob | undefined;

  currentImage: any;

  fetchingImage: boolean = true;

  CarBusinessLine = CarBusinessLine;

  constructor(
    private router: Router,
    private store: Store, 
    private readonly sanitizer: DomSanitizer,
    public dialog: MatDialog) {

    }

  ngOnInit(): void {

    if(this.carImage != undefined){
        this.currentImage = this.getCarImage();
    }
  }

  moneyFormat(s: string): string{
    return AppFunctions.numberWithSpaces(s);
  }

  dateFormat(dt: string): string{

    return AppFunctions.stringToDate(dt);
  }

  createImageFromBlob(imageData: Blob): any {
    let objectUrl = URL.createObjectURL(imageData);     
    return this.sanitizer.bypassSecurityTrustUrl(objectUrl);    
  }

  getCarImage(): any{

    let objectUrl = URL.createObjectURL(this.carImage!);     
    return this.sanitizer.bypassSecurityTrustUrl(objectUrl); 

  }

  goToCarDetailsPageOld(carId: string): any{

    this.router.navigate(
      ['/'+this.businessLine!.toString().toLowerCase()+'/details'],
      { queryParams: { id: carId} }
    );
  }

  goToCarDetailsPage(carId: string, offerId: string): any{

    switch(this.businessLine!.toString()){

      case CarBusinessLine.BUY.toString(): {
        this.router.navigate(
          ['/buy/details'],
          { queryParams: { carId: carId, offerId: offerId} }
        );
        break;
      }

      case CarBusinessLine.RENT.toString(): {
        this.router.navigate(
          //['/rent/booking'],
          ['/rent/details'],
          { queryParams: { carId: carId, offerId: offerId} }
        );
        break;
      }

    } 
  }

  toggleFavorite(carId: string, offerId: string): any{

    //let car: Car = Object.assign(new Car(), this.carBrief);

    this.store.dispatch(DealerActions.toggleFavoriteSubmit( { objectId: offerId === "" ? carId :offerId, objectClass: offerId === "" ? ObjectClass.CAR : ObjectClass.OFFER, makeFav: !this.carBrief.favorite, businessLine: this.businessLine! }))
  }

  shareCar(carId: string): any{

    let car: Car = Object.assign(new Car(), this.carBrief);

    //this.store.dispatch(DealerActions.toggleFavoriteSubmit( {car: car, makeFav: !this.carBrief.favorite, businessLine: this.businessLine! }))
  }

}
